import React from "react";
import { Form, Input } from "antd";
import "./styles.css";

const { Item } = Form;

const InputString = (props) => {
  const {
    id,
    placeholder,
    name,
    label,
    required,
    value,
    onChangeHandler,
    disabled = false,
    verified = false,
  } = props;

  return (
    <div>
      <Item
        key={id}
        name={name}
        label={label}
        size="true"
        rules={[
          {
            required: required,
          },
        ]}
      >
        <Input
          id={label}
          placeholder={placeholder}
          className="form-input-element"
          value={value}
          size="small"
          onChange={(e) => onChangeHandler(e.target.value, id)}
          autoComplete="off"
          disabled={disabled}
          suffix={
            verified ? (
              <span className="field-verified-badge">
                <img src="/assets/icons/success.svg" alt="verified" />
              </span>
            ) : null
          }
        />
      </Item>
    </div>
  );
};

export default InputString;
